// extracted by mini-css-extract-plugin
export default {"textButton":"textButton__Xxaqe","secondary":"secondary__Iillw","inline":"inline__lv4Sx"};